module.exports = __webpack_public_path__ + "assets/img/teacher (10).106f12f8.png";